import axios from "axios";

/**
 * Use a relative base URL so the API always hits the same origin the app was
 * loaded from. This eliminates cross-subdomain CORS issues when the preview
 * hostname changes, and is the canonical pattern for same-domain frontend+API
 * deployments.
 *
 * The configured REACT_APP_BACKEND_URL is honoured ONLY when it matches the
 * current page origin (defensive). Otherwise we fall back to same-origin.
 */
function resolveBase() {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  if (fromEnv && typeof window !== "undefined") {
    try {
      const envOrigin = new URL(fromEnv).origin;
      if (envOrigin === window.location.origin) return fromEnv;
    } catch { /* ignore */ }
  }
  return ""; // same-origin
}

export const api = axios.create({
  baseURL: `${resolveBase()}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("aarya_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
